export const ADMIN_OPERATE_CAPABILITY = 'admin:operate' as const;

type CapabilityResponse = {
  capabilities?: unknown;
};

type FetchLike = (
  input: RequestInfo | URL,
  init?: RequestInit,
) => Promise<Response>;

/**
 * Read the server-issued Admin capabilities for the current session.
 * A 401/403 is a valid denial; malformed success responses fail closed.
 */
export async function fetchAdminCapabilities(
  accessToken: string,
  request: FetchLike = fetch,
): Promise<readonly string[]> {
  const response = await request('/api/admin/capability', {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (response.status === 401 || response.status === 403) {
    return [];
  }

  if (!response.ok) {
    throw new Error('Admin capability service unavailable');
  }

  const body = await response.json() as CapabilityResponse;
  if (!body || !Array.isArray(body.capabilities) || body.capabilities.some((value) => typeof value !== 'string')) {
    throw new Error('Admin capability response is invalid');
  }

  return body.capabilities;
}
